import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class TransCatgSyncService {

  constructor(private http: HttpClient) { }

  /**
   * Save/initiate Trans Category Sync process
   * Original action_code: 'ghtqbf' using saveJSON endpoint
   */
  saveTransCatgSync(
    baseUrl: string,
    params: any,
    globalParams: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject';

    // Merge order: globalParams first, then filterParams, then explicit params (highest priority)
    let mergedParams = _.merge({}, globalParams || {}, filterParams || {}, params);

    // Ensure required parameters are explicitly set from params (highest priority)
    mergedParams.action_code = params.action_code || 'ghtqbf';
    mergedParams.sso_id = params.sso_id;
    mergedParams.tax_year = params.tax_year;
    mergedParams.scenario = params.scenario;
    mergedParams.jcd_key = params.jcd_key;
    mergedParams.trans_catg_key = params.trans_catg_key;

    // Ensure required backend parameters are present (from globalParams or defaults)
    mergedParams.scenarioCode = mergedParams.scenarioCode || globalParams?.scenarioCode || filterParams?.scenarioCode || 'RAF';
    mergedParams.is_issue_key_enabled = mergedParams.is_issue_key_enabled || globalParams?.is_issue_key_enabled || filterParams?.is_issue_key_enabled || 'N';

    // Build URL encoded params
    const urlEncoded = new URLSearchParams();
    Object.keys(mergedParams).forEach(key => {
      if (mergedParams[key] !== undefined && mergedParams[key] !== null) {
        urlEncoded.set(key, mergedParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
